import React, { Fragment } from 'react';
import { useFormContext } from 'react-hook-form';
import Tooltip from '../../tooltip/TooltipWrapper';
import '../../tooltip/tooltip.css';

function Select(props) {
  let spacingClasses = 'pl-5 pr-5 md:pl-0 md:pr-0 pb-30 relative ' + (props.spacingClasses ? props.spacingClasses : '');
  const { register } = useFormContext();

  return (
    <div className={spacingClasses} id={props.tooltipName}>
      <label
        className={'mb-5 font-mont-700 font-w-400 text-12 tracking-1 uppercase flex relative ' + (props.tooltip ? 'leading-17 -mt-5' : 'leading-12')}
        htmlFor={props.for}
      >
        {props.label}
        {props.tooltip && (
          <Tooltip
            aria={{ content: 'describedby', expanded: false }}
            content={props.tooltip}
            trigger="click"
            role="tooltip"
            interactive={true}
            animation={'fade'}
            duration={250}
            popperOptions={{
              modifiers: [
                {
                  name: 'offset',
                  options: {
                    offset: [0, 20],
                  },
                },
                {
                  name: 'flip',
                  options: {
                    fallbackPlacements: ['top', 'bottom'],
                    allowedAutoPlacements: ['top', 'bottom'],
                    padding: 50,
                  },
                },
                {
                  name: 'preventOverflow',
                  options: {
                    boundary: typeof window !== 'undefined' ? document.querySelector(`#${props.tooltipName}`) : 'viewport',
                    padding: 0,
                  },
                },
              ],
            }}
          >
            <button type="button" aria-label={"Additional information about the '" + props.label + "' field"} className="rounded-full leading-17 ml-5">
              <svg
                aria-hidden="true"
                data-icon="info-circle"
                className="text-info-blue"
                style={{ width: '17px' }}
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
              >
                <path
                  fill="currentColor"
                  d="M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 110c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z"
                ></path>
              </svg>
            </button>
          </Tooltip>
        )}
      </label>
      <div className="relative" style={{ background: props.disabled ? 'rgba(158, 158, 158, .5)' : '' }}>
        <select
          name={props.name}
          ref={register}
          className={`block appearance-none w-full font-museo font-w-300 p-15 leading-22 text-17 h-55 border-solid border-1 bg-white ${
            props.error && !props.disabled ? 'border-error-red' : 'border-middle-grey'
          }`}
          style={{ cursor: props.disabled ? 'no-drop' : '' }}
          id={props.id}
          disabled={props.disabled}
          defaultValue={props.defaultValue}
          onChange={option => {
            if (props.selectOnClick) {
              props.selectOnClick(option);
            }
          }}
          aria-invalid={props.error != undefined}
          aria-describedby={'error-' + props.for + ' caption-' + props.for}
        >
          {props.options.map((value, key) => (
            <option
              key={key}
              value={props.values ? props.values[key] : key === 0 && props.nullFirstValue ? '' : value}
              disabled={key === 0 && props.disableFirstValue ? true : null}
            >
              {value}
            </option>
          ))}
        </select>
        <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-15 text-gray-700">
          <svg
            aria-hidden="true"
            focusable="false"
            data-prefix="far"
            data-icon="chevron-down"
            role="img1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 448 512"
            className="w-15 h-15"
          >
            <path
              fill="#111"
              d="M441.9 167.3l-19.8-19.8c-4.7-4.7-12.3-4.7-17 0L224 328.2 42.9 147.5c-4.7-4.7-12.3-4.7-17 0L6.1 167.3c-4.7 4.7-4.7 12.3 0 17l209.4 209.4c4.7 4.7 12.3 4.7 17 0l209.4-209.4c4.7-4.7 4.7-12.3 0-17z"
            ></path>
          </svg>
        </div>
      </div>
      <small id={'error-' + props.for} className="text-error-red absolute" style={{ bottom: '10px' }} aria-live="assertive">
        {!props.disabled && props.error && (
          <Fragment>
            {props.label.replace('?', '')} is {props.error.type === 'required' ? 'required' : 'invalid'}
          </Fragment>
        )}
      </small>
      <small id={'caption-' + props.for} className="text-14 leading-18 font-w-400 text-dark-grey absolute" style={{ bottom: '8px' }} aria-live="polite">
        {!props.disabled && props.caption && !props.error && <Fragment>{props.caption}</Fragment>}
      </small>
    </div>
  );
}

export default Select;
